// src/theme.ts
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      light: "#63a4ff", // Lighter shade of blue
      main: "#1976d2", // Primary blue
      dark: "#004ba0", // Darker blue
      contrastText: "#fff", // Text color for primary buttons
    },
    secondary: {
      light: "#E6D7FF", // Light pink
      main: "#D9ACFA", // Secondary color
      dark: "#9D76C4", // Dark pink
      contrastText: "#fff", // Text color for secondary buttons
    },
    background: {
      default: "#f4f6f8", // Default background
      paper: "#fff", // Background color for Paper component
    },
    text: {
      primary: "#333", // Primary text color
      secondary: "#666", // Secondary text color
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2.5rem",
      fontWeight: 600,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 600,
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 500,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 400,
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    button: {
      textTransform: "none", // Disable uppercase transformation on buttons
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8, // Set a uniform border-radius for components like Button, Paper, etc.
  },
  spacing: 8, // The base spacing unit (8px)
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px", // Custom border radius for buttons
          padding: "8px 16px", // Custom padding for buttons
        },
        containedPrimary: {
          backgroundColor: "#1976d2",
          "&:hover": {
            backgroundColor: "#1565c0", // Darker on hover
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          padding: "16px", // Default padding for Paper components
          boxShadow: "0px 3px 6px rgba(0,0,0,0.1)", // Custom shadow
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: "8px", // Default margin for TextFields
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});
